import { UntypedFormGroup } from '@angular/forms';

export class ValidatableFormComponent {
  form: UntypedFormGroup;

  validate(): boolean {
    Object.keys(this.form.controls).forEach(k => {
      this.form.get(k).markAsTouched();
    });

    return this.form.valid;
  }
}
